<template>
  <div id="app">
    <alert></alert>
    <router-view></router-view>
  </div>
</template>

<script>
import Alert from './components/Alert'
import League from './components/League'

export default {
  components: {
    League,
    Alert
  }
}
</script>

<style>

  @font-face {
      font-family: 'steagalbold';
      src: url('./assets/fonts/steagal-bo-webfont.woff2') format('woff2'),
           url('./assets/fonts/steagal-bo-webfont.woff') format('woff');
      font-weight: normal;
      font-style: normal;

  }

  @font-face {
      font-family: 'steagallight';
      src: url('./assets/fonts/steagal-li-webfont.woff2') format('woff2'),
           url('./assets/fonts/steagal-li-webfont.woff') format('woff');
      font-weight: normal;
      font-style: normal;

  }

  body {
    margin: 0rem;
    font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  }
</style>



/** WEBPACK FOOTER **
 ** App.vue?9c131efc
 **/